export namespace AppSettings {
    export class Paths {
      
        static BaseAssetsPath: string = "assets/";
        static BaseModelsPath: string = "static/models/";
        static BaseMaterialsPath: string = "static/materials/";

        static MoveIcon: string = "images/icons/move.png"
        static LinkIcon: string = "images/icons/link.png"
        static LinkedIcon: string = "images/icons/linked.png"
        static LinkMaleBlueIcon: string = "images/icons/link-male-blue.png"
        static LinkFemaleBlueIcon: string = "images/icons/link-female-blue.png"
        static LinkMaleRedIcon: string = "images/icons/link-male-red.png"
        static LinkFemaleRedIcon: string = "images/icons/link-female-red.png"
        static LinkMaleGreenIcon: string = "images/icons/link-male-green.png"
        static LinkFemaleGreenIcon: string = "images/icons/link-female-green.png"
        static InsertIcon: string ="images/icons/insert.png"
        static DeleteIcon: string =  "images/icons/delete.png"
        static RotateIcon: string = "images/icons/rotate.png"
    }
    
}   
